<div class="filter-top-bar justify-content-start" #filterTopBar>
  <div class="search-control d-flex align-items-center me-10">
    <input type="search" class="form-control table-search" [formControl]="searchControl" />
    <span class="icon-search position-absolute px-10"></span>
  </div>
  <div class="filter-wrapper dropdown">
    <div
      class="filter-tabs-holder"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
      [cdkDropListConnectedTo]="[deleteArea]">
      <div *ngFor="let filter of filters" cdkDrag (cdkDragStarted)="isBeingDragged = true" (cdkDragEnded)="isBeingDragged = false">
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <div class="filter-tab" *ngIf="filter.show">
          <a
            cdkDragHandle
            class="dropdown-toggle d-flex justify-content-center align-items-center"
            role="button"
            id="filter-{{ filter.filterKey }}"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside"
            [ngClass]="{ active: isFilterActive(filter) }">
            <!--<span class="icon-drag-indicator"></span>-->
            {{ filter.title }}
            <span *ngIf="getPeekForSelectedValues(filter) as peekValue">({{ peekValue | truncate: 4 }})</span>
          </a>

          <form [formGroup]="form">
            <div
              *ngIf="filter.filterKey === 'users'"
              class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="user-filter-drop">
                <app-users-select
                  source="sessions"
                  [multiple]="true"
                  (clear)="onClear($event)"
                  (selectUser)="onSelectUser($event)"
                  (unSelectUser)="onUnSelectUser($event)"></app-users-select>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'sessionIds'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  class="form-control pb-5"
                  formControlName="sessionIds"
                  placeholder="Search by Session IDs - separate multiple values by space" />
                <input-errors [control]="form.controls.sessionIds" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'supplierIds'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  class="form-control pb-5"
                  formControlName="supplierIds"
                  placeholder="Search by Supplier IDs - separate multiple values by space" />
                <input-errors [control]="form.controls.supplierIds" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'host'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" class="form-control pb-5" formControlName="host" placeholder="Search by host" />
                <input-errors [control]="form.controls.host" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'logins'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  class="form-control pb-5"
                  formControlName="logins"
                  placeholder="Search by login - separate multiple values by space" />
                <input-errors [control]="form.controls.logins" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'status'"
              class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="d-flex justify-content-end me-10">
                  <span class="cp text-neutral-n7 status-text text-decoration-underline" (click)="onClear('status')">Clear all</span>
                </div>
                <div
                  *ngFor="let statusOption of statusOptions"
                  class="d-flex justify-content-start align-items-center gap-10 my-10 cp"
                  (click)="onChangeStatus(statusOption.value)">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('status')?.value?.includes(statusOption.value)" />
                  </div>
                  <i [class]="statusOption.iconClass"></i>
                  <span>{{ statusOption.text }}</span>
                </div>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'supplierNames'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  class="form-control pb-5"
                  formControlName="supplierNames"
                  placeholder="Search by Supplier name - separate multiple values by space" />
                <input-errors [control]="form.controls.supplierNames" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'routeType'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" class="form-control pb-5" formControlName="routeType" placeholder="Search by route type" />
                <input-errors [control]="form.controls.routeType" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'serviceType'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" class="form-control pb-5" formControlName="serviceType" placeholder="Search by service type" />
                <input-errors [control]="form.controls.serviceType" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="filter-add-btn" *ngIf="shouldAddFilterBeShown()">
      <a role="button" id="add-filter-link" data-bs-toggle="dropdown" aria-expanded="false"><span class="icon-add"></span> Add Filter</a>
      <ul class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="add-filter-link">
        <ng-container *ngFor="let filter of filters">
          <li *ngIf="!filter.show" class="dropdown-item filter-item px-15 py-10" (click)="onAdditionalFilterClick(filter)">
            <a>{{ filter.title }}</a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="v-line"></div>
    <div cdkDropList #deleteArea="cdkDropList" (cdkDropListDropped)="deleteItem($event)">
      <div
        class="delete-area d-flex justify-content-center align-items-center"
        [ngClass]="{ 'drag-active': isBeingDragged }"
        (click)="onClearAllFilter()">
        <span class="far fa-trash-alt"></span>
        {{ isBeingDragged ? 'Remove Filter' : 'Clear Filters' }}
      </div>
    </div>
  </div>
</div>
